import { core } from "./core";
import { onboardingEvents } from "./onboarding";
import { bookingEvents } from "./booking";
import { growthEvents } from "./growth";
import { discoveryEvents } from "./discovery";

/**
 * The app-wide tracking singleton. Shared state + the track() fan-out live on
 * TrackingCore (core.ts); each domain's event methods live in a "method bag"
 * module and are merged on here. Every method uses a `this: TrackingCore`
 * receiver, so `tracking.someEvent()` binds back to the core and reaches
 * PostHog + GTM + native FB through the single track() path.
 *
 * Call sites import the default export — `import tracking from "@/lib/tracking"`
 * — and this folder's index keeps that path stable after the split.
 */
const tracking = Object.assign(
  core,
  onboardingEvents,
  bookingEvents,
  growthEvents,
  discoveryEvents,
);

export default tracking;

// Lifecycle component + server-side tracker bridge
export { TrackingInitializer } from "./initializer";

// Raw per-channel emitters (used directly in a few spots)
export {
  tiktokEvent,
  gtagEvent,
  fbqEvent,
  gtmEvent,
  posthogEvent,
} from "./channels";

// Rewardful + Facebook attribution
export {
  getRewardfulClient,
  captureFacebookAttribution,
  logFacebookAttribution,
  getStoredFacebookAttribution,
} from "./attribution";
export type { Rewardful, FacebookAttributionData } from "./attribution";
